import { render, staticRenderFns } from "./PasswordSignupForm.vue?vue&type=template&id=3e28af54&scoped=true"
import script from "./PasswordSignupForm.vue?vue&type=script&lang=js"
export * from "./PasswordSignupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e28af54",
  null
  
)

export default component.exports